export default [
  [0.0600, 0.0800, 0.0800, 0.0800, 0.0800, 0.0800],
  [0.0700, 0.0700, 0.0700, 0.0700, 0.0700, 0.0700],
  [0.1000, 0.1000, 0.1000, 0.1000, 0.1000, 0.1000],
  [0.1250, 0.1250, 0.1250, 0.1250, 0.1250, 0.1250],
  [0.1750, 0.1750, 0.1750, 0.1750, 0.1750, 0.1750],
  [0.2200, 0.2200, 0.2200, 0.2200, 0.2200, 0.2200],
  [0.2500, 0.2500, 0.2500, 0.2500, 0.2500, 0.2500],
] as const;
